import React from 'react'

const IconGoBack= ({fillColor, style, ...props}) => {
  return (
   <svg {...props} xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style}  viewBox="0 -960 960 960">
      <path d="M402.46-166.15 206.15-362.46l196.43-196.42 25.96 26.57-151.19 151.19h399.57v-372.73h36.93v409.66h-436.5l151.69 151.46-26.58 26.58Z"/>
   </svg>
  )
}
export default IconGoBack 